const BaseError = require('make-error').BaseError;

class NotFoundError extends BaseError {
    constructor(errorMessage='Could not find any record matching the criteria') {
        super(errorMessage);
        this._isUserError = true;
    }
}

module.exports = NotFoundError;